import React from 'react';
import { StyleSheet, View} from 'react-native';
import VerticalSlider from 'rn-vertical-slider';
import VolumeContext from './VolumeContext'


const VolumeSlider = (props) => {

  const [volume, setVolume] = React.useContext(VolumeContext)
  const visibility = props.visibility

  const styles = StyleSheet.create({
    volumeSlider:
      {position: 'absolute', right: 86, top:64, zIndex: 1, visibility: visibility,
      elevation: 5,
    }
  })

  return (
      <View style={styles.volumeSlider}>
          <VerticalSlider
            value={volume}
            min={0}
            max={100}
            onChange={(value: number) => {
              setVolume(value)
            }}
            width={36}
            height={100}
            step={5}
            minimumTrackTintColor={"#2196F3"}
            maximumTrackTintColor={"#bdbdbd"}
            shadowProps = {{
              shadowRadius: 5,
              shadowOpacity: 0.5,
              shadowOffsetHeight: 2
            }}
          />
        </View>
  )
}

export default VolumeSlider
